import React, { ComponentType } from "react";
import BookedBy from "./index";
import { IBaseProps, IContainerProps, IProps } from './types'
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const propsKeys = keys<IBaseProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();

const classPrefix = 'BookedByForm';
const ThemeWrap = function(all: IContainerProps) {
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IContainerProps;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  /**
   * Passes all base props from container to component
   */
// @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  return ReactUtilsService.containerWrap(
      <BookedBy
        {...props}
      />, classPrefix
  );
}

const R2AExistingCustomerSearch: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
];

export default R2AExistingCustomerSearch
